<template>
  <div class="page-container">
    <div class="doc-wrapper">
      <h1 class="main-title">{{ txt.title }}</h1>
      <div class="meta-info">LAST UPDATED: 2024-05-20 | PROTOCOL VERSION: v2.1.0</div>

      <section class="doc-section">
        <h2>1. {{ txt.core.title }}</h2>
        <p>{{ txt.core.p1 }}</p>
        <p>{{ txt.core.p2 }}</p>
      </section>

      <section class="doc-section">
        <h2>2. {{ txt.immutable.title }}</h2>
        <p>{{ txt.immutable.p1 }}</p>
        <div class="code-block">
          <code>
            // Verdict Liquidity Pool Logic<br>
            function withdraw(uint256 amount) public nonReentrant {<br>
            &nbsp;&nbsp;require(balanceOf[msg.sender] >= amount, "Insufficient balance");<br>
            &nbsp;&nbsp;payable(msg.sender).transfer(amount);<br>
            }
          </code>
        </div>
        <p>{{ txt.immutable.p2 }}</p>
      </section>

      <section class="doc-section">
        <h2>3. {{ txt.oracle.title }}</h2>
        <p>{{ txt.oracle.p1 }}</p>
        <ul class="dense-list">
          <li><strong>{{ txt.oracle.l1 }}</strong></li>
          <li><strong>{{ txt.oracle.l2 }}</strong></li>
          <li><strong>{{ txt.oracle.l3 }}</strong></li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import DICT from '../locales/data.js';

export default {
  props: ['lang'],
  computed: { txt() { return DICT[this.lang].security || DICT['en'].security } }
}
</script>

<style scoped>
.page-container { padding: 40px 0 100px; background: #000; min-height: 100vh; color: #ccc; }
.doc-wrapper { max-width: 900px; margin: 0 auto; padding: 40px; background: #0a0b10; border: 1px solid #222; border-radius: 8px; }
.main-title { color: #fff; font-size: 32px; font-weight: 800; margin-bottom: 10px; border-bottom: 1px solid #333; padding-bottom: 20px; }
.meta-info { font-size: 11px; color: #555; margin-bottom: 40px; font-family: monospace; letter-spacing: 1px; }
.doc-section { margin-bottom: 50px; }
h2 { color: #fff; font-size: 20px; border-left: 3px solid #ff5e57; padding-left: 15px; margin-bottom: 20px; }
p { font-size: 14px; line-height: 1.8; margin-bottom: 15px; color: #aaa; text-align: justify; }
.code-block { background: #111; border: 1px solid #333; padding: 15px; border-radius: 6px; font-family: monospace; color: #00D092; font-size: 12px; margin: 20px 0; overflow-x: auto; }
.dense-list { list-style: none; padding: 0; }
.dense-list li { margin-bottom: 10px; font-size: 14px; color: #ccc; }
.dense-list strong { color: #fff; }
@media(max-width: 768px) { .doc-wrapper { padding: 20px; border: none; } }
</style>